import { ReactComponent as MoneybirdLogo } from '../styles/svg/moneybird.svg';
import { ReactComponent as MoneybirdWhiteLogo } from '../styles/svg/moneybird_white.svg';

import { ReactComponent as AfasLogo } from '../styles/svg/afas.svg';
import { ReactComponent as StockhubLogo } from '../styles/svg/stockhub-logo-black.svg';
import { ReactComponent as StockhubLogoWhite } from '../styles/svg/stockhub-logo-white.svg';

export const getLogoElement = (type, width = 30, height = 30, variant = null) => {
    switch (type) {
        case "moneybird":
            if (variant === "white") {
                return <MoneybirdWhiteLogo width={width} height={height}/>;
            } else {
                return <MoneybirdLogo width={width} height={height}/>;
            }
        case "afas":
            if (variant === "white") {
                return <AfasLogo width={width} height={height}/>;
            } else {
                return <AfasLogo width={width} height={height}/>;
            }
        case "stockhub_pdf":
            if (variant === "white") {
                return <StockhubLogoWhite width={width} height={height}/>;
            } else {
                return <StockhubLogo width={width} height={height}/>;
            }
        default: return <></>;
    }
}